import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { CorrespondenceEmailModel } from "@rightship-tech/tasks-ui/models/tasks.models";
import { autoinject } from "aurelia-framework";

@autoinject
export class DialogAddPeopleToThisConversation {

    public toEmails: CorrespondenceEmailModel[] = [{ email: "", emailRecipientTypeId: 1 }];
    addPeopleToConversation: (emails: CorrespondenceEmailModel[]) => void;

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService) { }

    activate(model: { addPeopleToConversationFn: (emails: CorrespondenceEmailModel[]) => void, peopleAddedToConversation: CorrespondenceEmailModel[]}) {
        
        this.addPeopleToConversation = model.addPeopleToConversationFn;

        if (model.peopleAddedToConversation.length != 0) {
            this.toEmails = model.peopleAddedToConversation
        }
    }

    close() {
        this.dialogClientService.hide();
    }

    addEmail() {
        this.toEmails.push({ email: "", emailRecipientTypeId: 1 });
    }

    removeEmail(index: number) {
        this.toEmails.splice(index, 1);
    }

    async confirm() {

        //Done it in a simple way to avoid any issues for the release, best to be done in a better way with a custom validation renderer
        
        //Validate email addresses
        let validEmails = this.toEmails.filter(email => this.isValidEmail(email.email));
        if(validEmails.length == this.toEmails.length) {
            this.addPeopleToConversation(this.toEmails);
            this.dialogClientService.hide();
        }
        else {
            
            //Show error message
            this.notificationClientService.show("Invalid email address(es). Please check and try again.", "", NotificationType.Error);
            return;
        }
    }

    private isValidEmail(email: string): boolean {
        //Regular expression to validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
}